export const FORM_NAMES = {
  COUNTRY: 'country',
  ZIP_CODE: 'zipCode',
  STREET_ADDRESS: 'streetAddress',
  STREET_ADDRESS2: 'streetAddress2',
  CITY: 'city',
  STATE: 'state',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  PHONE: 'phone',
  COUNTRY_CODE: 'countryCode',
  COMPANY_NAME: 'companyName',
  CALLING_CODE: 'callingCode'
};

export const FORM_LABELS = {
  [FORM_NAMES.FIRST_NAME]: 'CAT_EMAIL_FIRSTNAME',
  [FORM_NAMES.LAST_NAME]: 'CAT_EMAIL_LASTNAME',
  [FORM_NAMES.STATE]: 'CAT_EMAIL_STATE',
  [FORM_NAMES.EMAIL]: 'CAT_EMAIL_EMAIL1',
  [FORM_NAMES.PHONE]: 'CAT_EMAIL_PHONE1',
  [FORM_NAMES.COUNTRY_CODE]: 'CAT_EMAIL_COUNTRY',
  [FORM_NAMES.COUNTRY]: 'COUNTRY_REGION',
  [FORM_NAMES.CITY]: 'CAT_EMAIL_CITY',
  [FORM_NAMES.ZIP_CODE]: 'CAT_EMAIL_ZIP',
  [FORM_NAMES.STREET_ADDRESS]: 'MOSB_STREET_ADDRESS',
  [FORM_NAMES.STREET_ADDRESS2]: 'CAT_EMAIL_ADDRESS_2',
  [FORM_NAMES.COMPANY_NAME]: 'CAT_EMAIL_COMPANYNAME'
};

export const INVALID_ZIP_CODE = /^\d+$/;
export const INVALID_EMAIL_REGEX =
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const INVALID_STREET_CHARS_STR = `\\,/,<,>,[,],{,},$,@,&,),(,;`;
export const INVALID_CHARS_STR = `\\,/,<,>,[,],{,},&,),(,;`;
export const INVALID_STREET_ADDRESS_CHARS_REGEX = /^[^\\/<>[\]{}$@&();]*$/;
export const INVALID_CHARS_REGEX = /^[^\\/<>[\]{}&();]*$/;
export const INPUTS_MAX_LENGTH = {
  firstName: 20,
  lastName: 20,
  email: 120,
  address1: 40,
  address2: 40,
  zipCode: 10,
  city: 40
};
